const applyCredentialRowMutation = (items, credentialId, mutate) => {
  if (!Array.isArray(items) || !credentialId) {
    return items;
  }

  let hasChanged = false;

  const nextItems = items.map((item) => {
    if (String(item?.credentialId || '').trim() !== credentialId) {
      return item;
    }

    const nextItem = mutate(item);

    if (nextItem === item) {
      return item;
    }

    hasChanged = true;
    return nextItem;
  });

  return hasChanged ? nextItems : items;
};

export default applyCredentialRowMutation;
